import { render, staticRenderFns } from "./email.vue?vue&type=template&id=5dc564da&scoped=true&"
import script from "./email.vue?vue&type=script&lang=js&"
export * from "./email.vue?vue&type=script&lang=js&"
import style0 from "./email.vue?vue&type=style&index=0&lang=css&"
import style1 from "./email.vue?vue&type=style&index=1&id=5dc564da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc564da",
  null
  
)

export default component.exports